// extracted by mini-css-extract-plugin
export default {"container":"mobile_container__RUCOh"};